/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAddLocation from '../../../../../../Icon/IconAddLocation';
import IconBeenhere from '../../../../../../Icon/IconBeenhere';
import IconDirections from '../../../../../../Icon/IconDirections';
import IconDirectionsBike from '../../../../../../Icon/IconDirectionsBike';
import IconDirectionsBoat from '../../../../../../Icon/IconDirectionsBoat';
import IconDirectionsBus from '../../../../../../Icon/IconDirectionsBus';
import IconDirectionsCar from '../../../../../../Icon/IconDirectionsCar';
import IconDirectionsRailway from '../../../../../../Icon/IconDirectionsRailway';
import IconDirectionsRun from '../../../../../../Icon/IconDirectionsRun';
import IconDirectionsSubway from '../../../../../../Icon/IconDirectionsSubway';
import IconDirectionsTransit from '../../../../../../Icon/IconDirectionsTransit';
import IconDirectionsWalk from '../../../../../../Icon/IconDirectionsWalk';
import IconEditLocation from '../../../../../../Icon/IconEditLocation';
import IconEvStation from '../../../../../../Icon/IconEvStation';
import IconFlight from '../../../../../../Icon/IconFlight';
import IconHotel from '../../../../../../Icon/IconHotel';
import IconLayers from '../../../../../../Icon/IconLayers';
import IconLayersClear from '../../../../../../Icon/IconLayersClear';
import IconLocalActivity from '../../../../../../Icon/IconLocalActivity';
import IconLocalAirport from '../../../../../../Icon/IconLocalAirport';
import IconLocalAtm from '../../../../../../Icon/IconLocalAtm';
import IconLocalBar from '../../../../../../Icon/IconLocalBar';
import IconLocalCafe from '../../../../../../Icon/IconLocalCafe';
import IconLocalCarWash from '../../../../../../Icon/IconLocalCarWash';
import IconLocalConvenienceStore from '../../../../../../Icon/IconLocalConvenienceStore';
import IconLocalDining from '../../../../../../Icon/IconLocalDining';
import IconLocalDrink from '../../../../../../Icon/IconLocalDrink';
import IconLocalFlorist from '../../../../../../Icon/IconLocalFlorist';
import IconLocalGasStation from '../../../../../../Icon/IconLocalGasStation';
import IconLocalGroceryStore from '../../../../../../Icon/IconLocalGroceryStore';
import IconLocalHospital from '../../../../../../Icon/IconLocalHospital';
import IconLocalHotel from '../../../../../../Icon/IconLocalHotel';
import IconLocalLaundryService from '../../../../../../Icon/IconLocalLaundryService';
import IconLocalLibrary from '../../../../../../Icon/IconLocalLibrary';
import IconLocalMall from '../../../../../../Icon/IconLocalMall';
import IconLocalMovies from '../../../../../../Icon/IconLocalMovies';
import IconLocalOffer from '../../../../../../Icon/IconLocalOffer';
import IconLocalParking from '../../../../../../Icon/IconLocalParking';
import IconLocalPharmacy from '../../../../../../Icon/IconLocalPharmacy';
import IconLocalPhone from '../../../../../../Icon/IconLocalPhone';
import IconLocalPizza from '../../../../../../Icon/IconLocalPizza';
import IconLocalPlay from '../../../../../../Icon/IconLocalPlay';
import IconLocalPostOffice from '../../../../../../Icon/IconLocalPostOffice';
import IconLocalPrintshop from '../../../../../../Icon/IconLocalPrintshop';
import IconLocalSee from '../../../../../../Icon/IconLocalSee';
import IconLocalShipping from '../../../../../../Icon/IconLocalShipping';
import IconLocalTaxi from '../../../../../../Icon/IconLocalTaxi';
import IconMap from '../../../../../../Icon/IconMap';
import IconMyLocation from '../../../../../../Icon/IconMyLocation';
import IconNavigation from '../../../../../../Icon/IconNavigation';
import IconNearMe from '../../../../../../Icon/IconNearMe';
import IconPersonPin from '../../../../../../Icon/IconPersonPin';
import IconPersonPinCircle from '../../../../../../Icon/IconPersonPinCircle';
import IconPinDrop from '../../../../../../Icon/IconPinDrop';
import IconPlace from '../../../../../../Icon/IconPlace';
import IconRateReview from '../../../../../../Icon/IconRateReview';
import IconRestaurant from '../../../../../../Icon/IconRestaurant';
import IconRestaurantMenu from '../../../../../../Icon/IconRestaurantMenu';
import IconSatellite from '../../../../../../Icon/IconSatellite';
import IconStoreMallDirectory from '../../../../../../Icon/IconStoreMallDirectory';
import IconStreetview from '../../../../../../Icon/IconStreetview';
import IconSubway from '../../../../../../Icon/IconSubway';
import IconTerrain from '../../../../../../Icon/IconTerrain';
import IconTraffic from '../../../../../../Icon/IconTraffic';
import IconTrain from '../../../../../../Icon/IconTrain';
import IconTram from '../../../../../../Icon/IconTram';
import IconTransferWithinAStation from '../../../../../../Icon/IconTransferWithinAStation';
import IconZoomOutMap from '../../../../../../Icon/IconZoomOutMap';

export default function MapsIcons() {
  return (
    <div>
      <CategoryHeader>maps</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAddLocation size="32"/>
          <FigCaption>
            IconAddLocation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBeenhere size="32"/>
          <FigCaption>
            IconBeenhere
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirections size="32"/>
          <FigCaption>
            IconDirections
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsBike size="32"/>
          <FigCaption>
            IconDirectionsBike
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsBoat size="32"/>
          <FigCaption>
            IconDirectionsBoat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsBus size="32"/>
          <FigCaption>
            IconDirectionsBus
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsCar size="32"/>
          <FigCaption>
            IconDirectionsCar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsRailway size="32"/>
          <FigCaption>
            IconDirectionsRailway
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsRun size="32"/>
          <FigCaption>
            IconDirectionsRun
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsSubway size="32"/>
          <FigCaption>
            IconDirectionsSubway
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsTransit size="32"/>
          <FigCaption>
            IconDirectionsTransit
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDirectionsWalk size="32"/>
          <FigCaption>
            IconDirectionsWalk
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEditLocation size="32"/>
          <FigCaption>
            IconEditLocation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEvStation size="32"/>
          <FigCaption>
            IconEvStation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlight size="32"/>
          <FigCaption>
            IconFlight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHotel size="32"/>
          <FigCaption>
            IconHotel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLayers size="32"/>
          <FigCaption>
            IconLayers
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLayersClear size="32"/>
          <FigCaption>
            IconLayersClear
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalActivity size="32"/>
          <FigCaption>
            IconLocalActivity
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalAirport size="32"/>
          <FigCaption>
            IconLocalAirport
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalAtm size="32"/>
          <FigCaption>
            IconLocalAtm
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalBar size="32"/>
          <FigCaption>
            IconLocalBar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalCafe size="32"/>
          <FigCaption>
            IconLocalCafe
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalCarWash size="32"/>
          <FigCaption>
            IconLocalCarWash
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalConvenienceStore size="32"/>
          <FigCaption>
            IconLocalConvenienceStore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalDining size="32"/>
          <FigCaption>
            IconLocalDining
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalDrink size="32"/>
          <FigCaption>
            IconLocalDrink
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalFlorist size="32"/>
          <FigCaption>
            IconLocalFlorist
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalGasStation size="32"/>
          <FigCaption>
            IconLocalGasStation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalGroceryStore size="32"/>
          <FigCaption>
            IconLocalGroceryStore
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalHospital size="32"/>
          <FigCaption>
            IconLocalHospital
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalHotel size="32"/>
          <FigCaption>
            IconLocalHotel
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalLaundryService size="32"/>
          <FigCaption>
            IconLocalLaundryService
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalLibrary size="32"/>
          <FigCaption>
            IconLocalLibrary
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalMall size="32"/>
          <FigCaption>
            IconLocalMall
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalMovies size="32"/>
          <FigCaption>
            IconLocalMovies
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalOffer size="32"/>
          <FigCaption>
            IconLocalOffer
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalParking size="32"/>
          <FigCaption>
            IconLocalParking
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalPharmacy size="32"/>
          <FigCaption>
            IconLocalPharmacy
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalPhone size="32"/>
          <FigCaption>
            IconLocalPhone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalPizza size="32"/>
          <FigCaption>
            IconLocalPizza
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalPlay size="32"/>
          <FigCaption>
            IconLocalPlay
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalPostOffice size="32"/>
          <FigCaption>
            IconLocalPostOffice
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalPrintshop size="32"/>
          <FigCaption>
            IconLocalPrintshop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalSee size="32"/>
          <FigCaption>
            IconLocalSee
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalShipping size="32"/>
          <FigCaption>
            IconLocalShipping
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocalTaxi size="32"/>
          <FigCaption>
            IconLocalTaxi
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMap size="32"/>
          <FigCaption>
            IconMap
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMyLocation size="32"/>
          <FigCaption>
            IconMyLocation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNavigation size="32"/>
          <FigCaption>
            IconNavigation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNearMe size="32"/>
          <FigCaption>
            IconNearMe
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPersonPin size="32"/>
          <FigCaption>
            IconPersonPin
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPersonPinCircle size="32"/>
          <FigCaption>
            IconPersonPinCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPinDrop size="32"/>
          <FigCaption>
            IconPinDrop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPlace size="32"/>
          <FigCaption>
            IconPlace
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRateReview size="32"/>
          <FigCaption>
            IconRateReview
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRestaurant size="32"/>
          <FigCaption>
            IconRestaurant
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRestaurantMenu size="32"/>
          <FigCaption>
            IconRestaurantMenu
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSatellite size="32"/>
          <FigCaption>
            IconSatellite
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStoreMallDirectory size="32"/>
          <FigCaption>
            IconStoreMallDirectory
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStreetview size="32"/>
          <FigCaption>
            IconStreetview
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSubway size="32"/>
          <FigCaption>
            IconSubway
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTerrain size="32"/>
          <FigCaption>
            IconTerrain
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTraffic size="32"/>
          <FigCaption>
            IconTraffic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTrain size="32"/>
          <FigCaption>
            IconTrain
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTram size="32"/>
          <FigCaption>
            IconTram
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTransferWithinAStation size="32"/>
          <FigCaption>
            IconTransferWithinAStation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconZoomOutMap size="32"/>
          <FigCaption>
            IconZoomOutMap
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/MapsIcons.js